import axios from '../lib/request'
/*
	模式 $API文件占位符替换$
	替换方式：模块名大小驼峰替换
*/
export const adminUserApi = {
  saveAdminUser: (data) => {
    return axios.post(`/adminUser/saveAdminUser`, data)
  },
  deleteAdminUserByUid: (data) => {
    return axios.post(`/adminUser/deleteAdminUserByUid`, data)
  },
  queryAdminUserPage: (data) => {
    return axios.post(`/adminUser/queryAdminUserPage`, data)
  },
  queryAdminUserAll: () => {
    return axios.post(`/adminUser/queryAdminUserAll`)
  },
  updateAdminUserByUid: (data) => {
    return axios.post(`/adminUser/updateAdminUserByUid`, data)
  },
  adminResetPasswordByUid: (data) => {
    return axios.post(`/adminUser/adminResetPasswordByUid`, data)
  },
  adminLogin: (data) => {
    return axios.post(`/adminUser/adminLogin`, data)
  },
  getLoginAdminInfo: () => {
    return axios.post(`/adminUser/adminInfo`)
  },
  queryUserPage: (data) => {
    return axios.post(`/adminUser/queryUserPage`, data)
  },
  queryNearUser: (data) => {
    return axios.post(`/adminUser/queryNearUser`, data)
  },
  queryOrderGrabbingUser: (data) => {
    return axios.post(`/adminUser/queryOrderGrabbingUser`, data)
  },
  addCustomerRemark: (data) => {
    return axios.post(`/adminUser/addCustomerRemark`, data)
  },
  exportAllData: (data) => {
    return axios.post(`/adminUser/exportAllData`, data)
  },
  cancelUser: (data) => {
    return axios.post(`/adminUser/cancelUser`, data)
  },
  recoveryUser(data) {
    return axios.post('adminUser/recoveryUser', data)
  },
  searchUser(data) {
    return axios.post('adminUser/searchUser', data)
  },
  switchIsGeneralAgency(data) {
    return axios.post('adminUser/switchIsGeneralAgency', data)
  },
  addNurseRemark(data) {
    return axios.post('adminUser/addNurseRemark', data)
  },
  realTimeStatistics() {
    return axios.post('adminStatistics/realTimeStatistics')
  },
  updateBlackList(data) {
    return axios.post('adminUser/updateBlackList', data)
  },
  updateWhiteList(data) {
    return axios.post('adminUser/updateWhiteList', data)
  },
  adminGetSession(data) {
    return axios.post('adminUser/adminGetSession', data)
  },
  adminGetChat(data) {
    return axios.post('adminUser/adminGetChat', data)
  },
  queryOrderListById(data) {
    return axios.post('adminUser/queryOrderListById', data)
  },
  getProfessionCountStatistics(data) {
    return axios.post('adminUser/getProfessionCountStatistics', data)
  },
  resetUserUpdateLocationTime(data) {
    return axios.post('adminUser/resetUserUpdateLocationTime', data)
  }
}
